import React from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import InfoPage from '../../../models/InfoPage';
import InfoPageStore from '../../../store/InfoPageStore';
import InfoPageList from '../InfoPageList';
import TopLevelNavigationDropdown from '../../common/TopLevelNavigationDropdown';
import ConfigStore from '../../../store/ConfigStore';

export const InfoPageNavigation = ({
  infoPageStore,
  configStore,
  currentInfoPage,
}) => {
  const getActiveInfoPages = () => [
    ...currentInfoPage.ancestors,
    currentInfoPage,
  ];

  const getInfoPages = (id) => {
    return infoPageStore.pagesArray.filter(
      (page) => !page.parent_id && page.show_in_listing && page.id === id
    );
  };

  const activeInfoPages = currentInfoPage ? getActiveInfoPages() : [];

  return (
    <>
      {configStore.navigation.sidebar.enabled && <TopLevelNavigationDropdown />}
      <div className="InfoPageNavigation">
        {activeInfoPages.length > 0 && (
          <InfoPageList
            infoPages={getInfoPages(activeInfoPages[0].id)}
            activeInfoPages={activeInfoPages}
          />
        )}
      </div>
    </>
  );
};

InfoPageNavigation.propTypes = {
  infoPageStore: modelOf(InfoPageStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  currentInfoPage: modelOf(InfoPage),
};

export default inject(
  'infoPageStore',
  'configStore'
)(observer(InfoPageNavigation));
